import { CarrierRateChangeSetStatus } from "@redotech/crdb-enums/fulfillment/carrier-rate-change-set-status";
import * as z from "zod";

export const carrierRateChangeSetSchema = z.object({
  id: z.string(),
  carrier: z.string(),
  status: z.enum(CarrierRateChangeSetStatus),
  description: z.string(),
  createdBy: z.string(),
  createdAt: z.date(),
  decidedBy: z.string().nullable(),
  decidedAt: z.date().nullable(),
  decisionNote: z.string().nullable(),
});

export type CarrierRateChangeSet = z.infer<typeof carrierRateChangeSetSchema>;

export const carrierRateReviewSchema = z.object({
  diff: z.array(z.string()),
  backtest: z.array(z.string()),
});
